// Kresba na snímku „Firma dnes" (236): rozestavěný dům s lešením a věžový jeřáb
// s houpajícím se břemenem — terakotová linka. Pohyb respektuje prefers-reduced-motion
// (třídy pp-crane-swing / pp-crane-beacon v index.css).
const CRANE = "#e0703f";   // na terakotovém pruhu bílá (236/237)
const MAST = Array.from({ length: 10 }, (_, i) => 196 - i * 16).map((y) => `M226 ${y}L238 ${y - 16}M238 ${y}L226 ${y - 16}`).join("");
const JIB = [...Array.from({ length: 7 }, (_, i) => 150 + i * 12), ...Array.from({ length: 5 }, (_, i) => 244 + i * 12)]
  .map((x) => `M${x} 30L${x + 6} 24L${x + 12} 30`).join("");
const SCAF = Array.from({ length: 8 }, (_, i) => `M150 ${196 - i * 14}H172`).join("")
  + Array.from({ length: 4 }, (_, i) => 196 - i * 28).map((y) => `M150 ${y}L172 ${y - 14}M150 ${y - 14}L172 ${y - 28}`).join("");
const LIT = new Set(["0-1", "1-3", "2-0", "2-2"]);

export default function CraneArt({ className = "", color }) {
  const C = color || CRANE;
  return (
    <svg className={className} viewBox="0 0 320 200" fill="none" stroke={C} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <defs>
        <radialGradient id="pp-crane-glow"><stop offset="0" stopColor={C} stopOpacity=".22" /><stop offset="1" stopColor={C} stopOpacity="0" /></radialGradient>
      </defs>
      <ellipse cx="110" cy="176" rx="104" ry="44" fill="url(#pp-crane-glow)" stroke="none" />
      <path d="M8 196H316" strokeOpacity=".6" /><path d="M20 199h14M46 199h22M250 199h30" strokeOpacity=".35" />
      <path d="M40 196V110H150V196" />
      {[0, 1, 2].map((r) => [0, 1, 2, 3].map((c) => (
        <rect key={`${r}-${c}`} x={52 + c * 24} y={122 + r * 24} width="14" height="12" rx="1.5"
          {...(LIT.has(`${r}-${c}`) ? { fill: C, fillOpacity: ".55" } : {})} />
      )))}
      <path d="M96 196v-18h14v18" />
      <path d="M40 110V82M76 110V82M114 110V82M150 110V82M40 96H150M40 82H150" strokeOpacity=".75" />
      <path d="M40 110L76 96M76 110L114 96M114 110L150 96" strokeOpacity=".4" />
      <path d={`M172 196V96M150 96H172${SCAF}`} strokeOpacity=".7" />
      <path d={`M226 196V44M238 196V44${MAST}`} strokeOpacity=".9" />
      <path d={`M150 30H308M150 24H296M244 24V30${JIB}`} />
      <path d="M226 44V24h12v20" /><rect x="227" y="36" width="10" height="8" rx="1" fill={C} fillOpacity=".25" />
      <path d="M232 24V6M232 6L156 24M232 6L304 24" strokeOpacity=".7" />
      <rect x="288" y="31" width="20" height="13" rx="1.5" fill={C} fillOpacity=".35" />
      <circle className="pp-crane-beacon" cx="232" cy="5" r="2.6" fill={C} stroke="none" />
      <g className="pp-crane-swing">
        <path d="M178 30V86" /><path d="M178 86l-14 10M178 86l14 10" strokeOpacity=".8" />
        <rect x="160" y="96" width="36" height="7" rx="1.5" fill={C} fillOpacity=".85" />
      </g>
      <rect x="174" y="27" width="8" height="5" rx="1" fill={C} />
    </svg>
  );
}
